const interval = setInterval(() => {
  if (window.Swiper) {
    clearInterval(interval);

    document.querySelectorAll('.collection-swiper').forEach((section) => {
      new Swiper(section, {
        slidesPerView: 1.5,
        spaceBetween: 4,
        pagination: {},
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      });
    });

    document.querySelectorAll('.banner-swiper').forEach((elem) => {
      new Swiper(elem, {
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
      });
    });
  }
}, 200);

const options = { rootMargin: '0px 0px -50% 0px', threshold: 0.5 };
const intersectionObserver = new IntersectionObserver(function(entries) {
  if (entries[0].intersectionRatio <= 0) return;

  entries[0].target.classList.replace('tw-grayscale', 'tw-grayscale-0');
}, options);

document.querySelectorAll('.grayscale-on-scroll').forEach((elem) => intersectionObserver.observe(elem));

document.querySelectorAll('.info-overlay-swiper .info-close').forEach((elem) => {
  const infoOverlay = elem.closest('.info-overlay-swiper');

  const closeInfo = () => {
    infoOverlay.classList.replace('tw-opacity-100', 'tw-opacity-0');

    setTimeout(() => {
      infoOverlay.classList.add('tw-hidden');
    }, 200);
  };

  elem.addEventListener('touchstart', closeInfo);
  elem.addEventListener('click', closeInfo);
});
